import type { SchemaField } from '@cli-types/core-engine/schema.js'

export function createSchemaTitleField(label: string): SchemaField {
  return {
    name: 'title',
    type: 'string',
    label,
    required: true
  }
}
